var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99932 18.3324C14.0652 18.3324 17.4993 14.8982 17.4993 10.8324C17.4993 6.76654 14.0652 3.33237 9.99932 3.33237C5.93349 3.33237 2.49932 6.76654 2.49932 10.8324C2.49932 14.8982 5.93349 18.3324 9.99932 18.3324ZM9.99932 4.99904C13.161 4.99904 15.8327 7.6707 15.8327 10.8324C15.8327 13.994 13.161 16.6657 9.99932 16.6657C6.83766 16.6657 4.16599 13.994 4.16599 10.8324C4.16599 7.6707 6.83766 4.99904 9.99932 4.99904ZM14.4027 3.0882L15.5793 1.9082L18.0877 4.4082L16.9102 5.58904L14.4027 3.0882ZM4.40099 1.9107L5.58266 3.08737L3.09099 5.58737L1.91016 4.40987L4.40099 1.9107Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 7.5H10.8346V11.6667H9.16797V7.5ZM9.16797 12.5H10.8346V14.1667H9.16797V12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.87ef103ccd30dd34866d93b87a4b323c.svg";
export { ForwardRef as ReactComponent };